import {Injectable} from '@angular/core';
import {
  SimpleNotificationPreference,
  SimpleNotificationPreferenceAppSimpleNotificationEntitySimpleNotificationPreferenceRead,
  SimpleNotificationPreferenceService,
  SimpleNotificationTopicsService,
  WasteCollectionAreaAppEntityWasteWasteCollectionAreaRead,
  WasteCollectionAreaService,
  WasteNotificationSubscriptionService
} from '../openapi';
import {forkJoin, map, Observable, of} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {catchError} from "rxjs/operators";

export interface NotificationFormData {
  topics: string[];
  preferences: SimpleNotificationPreferenceAppSimpleNotificationEntitySimpleNotificationPreferenceRead[];
  areas: WasteCollectionAreaAppEntityWasteWasteCollectionAreaRead[];
  subscribedAreas: string[];
}

export interface NotificationFormParams {
  preferences: SimpleNotificationPreference[],
  subscribedAreas: string[]
}

@Injectable({
  providedIn: 'root'
})
export class MySettingsCommonService {
  constructor(
    private topicService: SimpleNotificationTopicsService,
    private simpleNotificationPreferenceService: SimpleNotificationPreferenceService,
    private wasteAreaService: WasteCollectionAreaService,
    private wasteNotificationSubscriptionService: WasteNotificationSubscriptionService,
    private http: HttpClient
  ) {
  }

  public updateFormData(payload: NotificationFormParams): Observable<NotificationFormData> {
    return forkJoin([
      this.topicService.getSimpleNotificationTopicsSimpleNotificationTopicsItem().pipe(
        map(v => v.names || []),
        catchError(() => of([]))
      ),
      this.http.put<SimpleNotificationPreferenceAppSimpleNotificationEntitySimpleNotificationPreferenceRead[]>(`${environment.apiBasePath}/simple_notification_preferences/my`, payload.preferences)
        .pipe(
          catchError(() => of([]))
        ),
      this.wasteAreaService.getWasteCollectionAreaCollectionWasteCollectionAreaCollection({
        pagination: false
      }).pipe(
        catchError(() => of([]))
      ),
      this.wasteNotificationSubscriptionService.updateMyWasteNotificationSubscriptionWasteNotificationSubscriptionItem({
        id: '',
        wasteNotificationSubscription: {
          areas: payload.subscribedAreas
        }
      }).pipe(
        map(v => v?.areas?.map(area => area.uuid || '') || []),
        catchError(err => of([]))
      )
    ]).pipe(
      map(([topics, preferences, areas, subscribedAreas]) => ({topics, preferences, areas, subscribedAreas}))
    )
  }

  public loadFormData(): Observable<NotificationFormData> {
    return forkJoin([
      this.topicService.getSimpleNotificationTopicsSimpleNotificationTopicsItem().pipe(
        map(v => v.names || []),
        catchError(() => of([]))
      ),
      this.simpleNotificationPreferenceService.getMyNotificationPreferencesSimpleNotificationPreferenceCollection({
        pagination: false
      }).pipe(
        catchError(() => of([]))
      ),
      this.wasteAreaService.getWasteCollectionAreaCollectionWasteCollectionAreaCollection({
        pagination: false
      }).pipe(
        catchError(() => of([]))
      ),
      this.wasteNotificationSubscriptionService.getMyWasteNotificationSubscriptionWasteNotificationSubscriptionItem({
        id: ''
      }).pipe(
        map(v => v.areas?.map(v => v?.uuid || '') || []),
        catchError(() => of([]))
      )
    ]).pipe(
      map(([topics, preferences, areas, subscribedAreas]) => ({topics, preferences, areas, subscribedAreas}))
    )
  }
}
